// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'd48c418c-deaa-4e2e-a7f3-895e422dfdf7',
      type: 'Sprite',
      name: 'island',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_2_Island',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        name: 'CAMPING SPOT',
        atlas: 'diorama_2',
        reward: {
          'Coin': 100,
          'BoosterHammer': 1,
        }
      }
    },
    {
      id: 'efc2f5be-132e-4d9a-9a01-d6d712b6a3ca',
      type: 'Sprite',
      name: 'tentShadow',
      className: '',
      x: -18,
      y: -214,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_2_Tent_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '051718ba-ae7d-4711-ada2-d2af38b35ec7',
      type: 'Sprite',
      name: 'tent',
      className: '',
      x: -25,
      y: -235,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_2_Tent',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 450,
        order: 2
      }
    },
    {
      id: '0b51bc60-ce70-4c90-bdf6-79f548f9b1a3',
      type: 'Sprite',
      name: 'carShadow',
      className: '',
      x: 156,
      y: -139,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_2_Camping_Car_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '0448a0de-cd12-4ba7-9f4e-a0ccd70b93f4',
      type: 'Sprite',
      name: 'car',
      className: '',
      x: 144,
      y: -181,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_2_Camping_Car',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 400,
        order: 1
      }
    },
    {
      id: 'ca1ea687-03aa-43bd-a595-0fe8969100b8',
      type: 'Sprite',
      name: 'treehouseShadow',
      className: '',
      x: 151,
      y: -340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_2_Treehouse_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '1975df14-685a-4845-b0bd-502694c869ba',
      type: 'Sprite',
      name: 'treehouse',
      className: '',
      x: 139,
      y: -346,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_2_Treehouse',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 850,
        order: 4
      }
    },
    {
      id: '3bd78ea4-76ed-427e-8981-091e3e9406d2',
      type: 'Sprite',
      name: 'campfireShadow',
      className: '',
      x: -149,
      y: -157,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_2_Campfire_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '02393d19-ccc2-4cff-8350-21bf8165173b',
      type: 'Sprite',
      name: 'campfire',
      className: '',
      x: -157,
      y: -170,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_2_Campfire',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 650,
        order: 3
      }
    },
    {
      id: 'eb078cc3-59e4-4f85-8c17-97f53f8e909d',
      type: 'Sprite',
      name: 'caveShadow',
      className: '',
      x: -53,
      y: -347,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_2_Cave_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '2acf50b8-cfc5-4acd-87ac-7d7f5b743292',
      type: 'Sprite',
      name: 'cave',
      className: '',
      x: -100,
      y: -410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_2_Cave',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1050,
        order: 5
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class Diorama_2 {
  static raw = raw;
  root!: Container;
  island!: Sprite & { data: typeof raw['list'][1]['data'] };
  tentShadow!: Sprite;
  tent!: Sprite & { data: typeof raw['list'][3]['data'] };
  carShadow!: Sprite;
  car!: Sprite & { data: typeof raw['list'][5]['data'] };
  treehouseShadow!: Sprite;
  treehouse!: Sprite & { data: typeof raw['list'][7]['data'] };
  campfireShadow!: Sprite;
  campfire!: Sprite & { data: typeof raw['list'][9]['data'] };
  caveShadow!: Sprite;
  cave!: Sprite & { data: typeof raw['list'][11]['data'] };
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
